import api from 'app/api'

export const inviteService = api.injectEndpoints({
  endpoints: (builder) => {
    return {
      checkInvitation: builder.query({
        query: ({ inviteId, roomId }) => ({
          url: `public/invites/${inviteId}/check/invite?roomId=${roomId ?? ''}`,
        }),
      }),
      // cancelInvitation: builder.mutation({
      //   query: ({ email, roomId }) => ({
      //     url: `invite/${roomId}/cancel`,
      //     method: 'PUT',
      //     body: { email },
      //   }),
      // }),
      checkResetPasswordLink: builder.mutation({
        query: (args) => ({
          url: `public/invites/${args.inviteId}/check/password`,
          method: 'GET',
        }),
      }),
      resendInvite: builder.mutation({
        query: (args) => ({
          url: `invite/resend`,
          method: 'POST',
          body: args,
        }),
      }),
    }
  },
})

export const {
  useResendInviteMutation,
  useLazyCheckInvitationQuery,
  //useCancelInvitationMutation,
  useCheckResetPasswordLinkMutation
} = inviteService
